import React, { useEffect, useState } from "react";
import { getPngUrl } from "../../helpers/avatarUrlUtils";

interface Prop {
    url?: string;
    avatarPngUrl?: string;
    showConfirm?: boolean;
    selectedAvatar?: any;
    handleSelect?: any;
    handleConfirm?: any;
    type?: string;
}

 function AvatarModelCard({ url, avatarPngUrl, showConfirm, selectedAvatar, handleSelect, handleConfirm, type }: Prop) {
    // Convert GLB URL to local PNG URL
    const pngUrl = url ? getPngUrl(url) : undefined;

    const [avatarUrls, setAvatarUrls] = useState<{default: string | null, selected: string | null}>({
        default: null,
        selected: null
    })

    const [avatarPngUrls, setAvatarPngUrls] = useState<{default: string | null, selected: string | null}>({
        default: null,
        selected: null
    })

    useEffect(() => {
        if(url && type) {
            const pose = type === "serious" ? "power-stance" : "thumbs-up";
            const defaultUrl = getPngUrl(url, { expression: 'happy' });
            const selectedUrl = getPngUrl(url, { expression: 'lol', pose: pose as any });

             // Preload the images
            const defaultImg = new Image();
            defaultImg.src = defaultUrl;

            const selectedImg = new Image();
            selectedImg.src = selectedUrl;

            setAvatarUrls({
                default: defaultUrl,
                selected: selectedUrl
            });
        }
        if(avatarPngUrl && type) {
            // avatarPngUrl is already a PNG path, extract the base and rebuild with expressions
            const pose = type === "serious" ? "power-stance" : "thumbs-up";
            const defaultAvatarPngUrl = getPngUrl(avatarPngUrl, { expression: 'happy' });
            const selectedAvatarPngUrl = getPngUrl(avatarPngUrl, { expression: 'lol', pose: pose as any });

            // Preload the images
            const defaultPngImg = new Image();
            defaultPngImg.src = defaultAvatarPngUrl;

            const selectedPngImg = new Image();
            selectedPngImg.src = selectedAvatarPngUrl;

            setAvatarPngUrls({
                default: defaultAvatarPngUrl,
                selected: selectedAvatarPngUrl
            });
        }
    }, [url, avatarPngUrl, type])

    return (
        <div onClick={() => handleSelect && handleSelect(url, pngUrl)} className="relative m-2 w-[10rem] h-[10rem] lg:h-[15rem] lg:w-[15rem] cursor-pointer p-2">
            {showConfirm && selectedAvatar === pngUrl &&  (
                <button
                    type="button"
                    className="absolute bottom-4 -translate-x-1/2 left-1/2 bg-primary text-white text-xs rounded-lg px-4 py-2"
                    onClick={() => handleConfirm && handleConfirm(url)}
                >
                    Confirm
                </button>
            )}
            <img
                className={
                        selectedAvatar === (url ? pngUrl : avatarPngUrl)
                        ? "border border-primary rounded-md shadow-custom"
                        : "transition-all"
                    }
                    src={
                       type === undefined
                         ? getPngUrl(url || '', { expression: 'happy' })
                         : pngUrl
                            ? (selectedAvatar === pngUrl
                                ? avatarUrls?.selected
                                : avatarUrls?.default) || getPngUrl(url || '', { expression: 'happy' })
                            : (selectedAvatar === avatarPngUrl
                                ? avatarPngUrls?.selected
                                : avatarPngUrls?.default) || getPngUrl(avatarPngUrl || '', { expression: 'happy' })
                    }
                alt={pngUrl ? pngUrl : avatarPngUrl}
            />
        </div>
    );
}

export default React.memo(AvatarModelCard)